// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"0c309af4","482":"bcd2876f","821":"0bb0fec1"}[chunkId] + ".chunk.js";
};